import { CommonCurrentPartnerType } from 'src/models/CurrentPartner';
import { FrontConfigurationFutureFlagsType, FrontConfigurationType } from 'src/models/FrontendConfiguration';
import { ApiFunctionNoParamType, httpGet, httpGetCancellable } from '../utils/http';

/** common frontend configuration */
export const apiGetConfiguration: ApiFunctionNoParamType<FrontConfigurationType> = httpGetCancellable(
  '/frontendconfiguration/configuration'
);

/** partner configuration */
export const apiGetPartnerConfiguration = (): Promise<CommonCurrentPartnerType> => httpGet('/partnerconfiguration/get');

/** future flags to decide which pages to show or not */
export const apiGetFrontendFeatureFlags = (): Promise<FrontConfigurationFutureFlagsType> =>
  httpGet('/frontendconfiguration/featureflags');

export const apiGetRecaptchaConfiguration: ApiFunctionNoParamType<{ SiteKey: string }> = httpGetCancellable(
  '/frontendconfiguration/RecaptchaConfiguration'
);
